import { decodeArray, encodeArray } from 'use-query-params';

const predicate = (val: string | null): val is string => Boolean(val);
const ArrayParam = {
    encode: (array: (string | null)[] | null | undefined) => encodeArray(array)?.filter(predicate),
    decode: (array: string | (string | null)[] | null | undefined) => decodeArray(array)?.filter(predicate),
};

export default ArrayParam;
